// extracted by mini-css-extract-plugin
module.exports = {"wrapperDiv":"PageChange_wrapperDiv__rrPiT","iconWrapper":"PageChange_iconWrapper__Irb0e","progress":"PageChange_progress__5saoB","title":"PageChange_title__z2p8E"};